import Casino from '@dialinvest/react-casino';

export const AddTrackingValue = (formElementsArray) => {
  if (document.cookie.indexOf(process.env.REACT_APP_EGASS_COOKIE_NAME) >= 0) {
    // eslint-disable-next-line max-len
    formElementsArray.userTrackingCodes = new Casino.Cookie().get(process.env.REACT_APP_EGASS_COOKIE_NAME);
  }
  return formElementsArray;
};
